import React from 'react'
import { Box, DataListItem } from '@node-space/ui-components'
import { RequestErrorCallout } from 'components/Errors/RequestErrorCallout'
import { AddCustomerActions } from 'pages/EmbeddedCustomers/AddCustomer/AddCustomerActions'
import type { MappedErrorMessageState } from 'types/errors'

interface ConfirmItem {
  id: string
  title: string
  body: string
}

interface ConfirmDetailsLayoutProps {
  confirmItems: ConfirmItem[]
  requestError: MappedErrorMessageState
  isSubmitting: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmDetailsLayout = ({
  confirmItems,
  requestError,
  isSubmitting,
  onConfirm,
  onCancel,
}: ConfirmDetailsLayoutProps) => {
  return (
    <>
      {requestError?.show && (
        <Box paddingT={24}>
          <RequestErrorCallout requestError={requestError} />
        </Box>
      )}
      {confirmItems.map(({ id, title, body }) => (
        <DataListItem key={id} id={id} title={title} body={body} />
      ))}
      <AddCustomerActions
        onCancel={onCancel}
        onConfirmDetails={onConfirm}
        isLoadingConfirm={isSubmitting}
      />
    </>
  )
}
